let pubKey = process.env.VUE_APP_PUB_KEY;
if (process.env.PUB_KEY){
  pubKey = process.env.PUB_KEY;
}

pubKey = pubKey && atob(pubKey);

export { pubKey };
